/**
 * Clinical Note API Service
 */

import apiClient from './apiClient';
import {
  ClinicalNoteDTO,
  CreateClinicalNoteRequest,
  ClinicalNoteType,
  PageResponse,
} from '../types/clinicalNote.types';

const BASE_PATH = '/v1/clinical-notes';

class ClinicalNoteService {
  async createClinicalNote(request: CreateClinicalNoteRequest): Promise<ClinicalNoteDTO> {
    const response = await apiClient.post<ClinicalNoteDTO>(BASE_PATH, request);
    return response.data;
  }

  async getClinicalNoteById(id: string): Promise<ClinicalNoteDTO> {
    const response = await apiClient.get<ClinicalNoteDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  }

  async getAllClinicalNotes(page: number = 0, size: number = 20): Promise<PageResponse<ClinicalNoteDTO>> {
    const response = await apiClient.get<PageResponse<ClinicalNoteDTO>>(BASE_PATH, {
      params: { page, size },
    });
    return response.data;
  }

  async getClinicalNotesByResident(residentId: string): Promise<ClinicalNoteDTO[]> {
    const response = await apiClient.get<ClinicalNoteDTO[]>(`${BASE_PATH}/resident/${residentId}`);
    return response.data;
  }

  async getClinicalNotesByType(noteType: ClinicalNoteType): Promise<ClinicalNoteDTO[]> {
    const response = await apiClient.get<ClinicalNoteDTO[]>(`${BASE_PATH}/type/${noteType}`);
    return response.data;
  }

  async updateClinicalNote(id: string, data: Partial<ClinicalNoteDTO>): Promise<ClinicalNoteDTO> {
    const response = await apiClient.put<ClinicalNoteDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  }

  async signClinicalNote(id: string): Promise<ClinicalNoteDTO> {
    const response = await apiClient.post<ClinicalNoteDTO>(`${BASE_PATH}/${id}/sign`);
    return response.data;
  }

  async deleteClinicalNote(id: string): Promise<void> {
    await apiClient.delete(`${BASE_PATH}/${id}`);
  }
}

export default new ClinicalNoteService();
